import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import { IoSearchSharp } from "react-icons/io5";
import ReactPaginate from "react-paginate";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

function Exchangetable({
  data,
  itemsPerPage,
  searchtext,
  setSearchtext,
  currentPage,
  setCurrentPage,
  type,
}) {
  console.log('data-->',data)
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
    setCurrentPage(0);
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm)
    )
  );

  const offset = currentPage * itemsPerPage;
  const currentItems = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handleClick = (id) => navigate(`/exchangedetail/${type}/${id}`);

  return (
    <div className="exchangetable">
      <Row className="justify-content-end ">
        <Col lg={6} xl={4}>
          <div class="position-relative allarrow">
            <input
              type="search"
              class="form-control"
              placeholder="name,symbol, or rank"
              onChange={(e) => {
                setSearchtext(e.target.value);
                setCurrentPage(0);
              }}
              value={searchtext}
            />
            <p class="mb-0 go">
              <IoSearchSharp />
            </p>
          </div>
        </Col>
      </Row>

      <div className="exchange_list py-2 mt-4">
        <Table responsive className="fulllist text-center">
          <thead>
            <tr>
              <th>EdaFace Rank</th>
              <th>Cex Spot</th>
              <th>Symbol</th>
              <th>24-hour Trade Volume</th>
              {/* <th>Average Liquidity</th> */}
              <th>Total Market Pairs </th>
              {/* <th>Weekly Visits</th> */}
              {/* <th>Weekly Volume Graph</th> */}
              <th>Total Listed Coins</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr
                className="listing_coin"
                onClick={() => handleClick(item?.exchangeId)}
                key={index}
              >
                <td>Rank {offset + index + 1}</td>
                <td>{item?.name}</td>
                <td>
                  {" "}
                  <img src={item.logo} className="coin" alt={item?.name} />
                </td>
                <td>{item.h_24volume?.current ?? 0}</td>
                {/* <td>{item.liquidity}</td> */}
                <td>{item.pairs}</td>
                {/* <td>{item.visits}</td> */}
                {/* <td><img src={item.graph} alt="bnb" /></td> */}
                <td>{item.coins}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <ReactPaginate
        previousLabel={<MdOutlineKeyboardArrowLeft />}
        nextLabel={<MdOutlineKeyboardArrowRight />}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default Exchangetable;
